// Models
import { Link, Program } from 'models';

function getNormalizedProgramLink(program: Program, link: Link): Link {
  const { label } = link;

  const programSiteUrl = new URL(program.siteUrl);

  let url: URL | string;

  try {
    url = new URL(link.url, program.siteUrl);

    url.protocol = programSiteUrl.protocol;
    url.hostname = programSiteUrl.hostname;
    url.port = programSiteUrl.port;

    for (const [key, value] of programSiteUrl.searchParams) {
      url.searchParams.delete(key);
      url.searchParams.set(key, value);
    }
  } catch {
    url = programSiteUrl;
  }

  url = `${url}`;

  return {
    label,
    url,
  };
}

export { getNormalizedProgramLink };
